<template>
    <div class="wrap" :class="{ wrap_en: $i18n.locale == 'EN' }">
        <my-header></my-header>
        <div class="section">
            <div class="banner">
                <transition name="slide-fade">
                    <div v-if="show">
                        <p>{{ $t('Public.Agriculture.banner.title') }}</p>
                        <div class="banner-txt">{{ $t('Public.Agriculture.banner.text') }}</div>
                    </div>
                </transition>
            </div>
            <div class="content">
                <div class="service_intro">
                    <p class="detail_title">{{ $t('Public.Agriculture.serviceIntro.title') }}</p>
                    <div class="intro_text">{{ $t('Public.Agriculture.serviceIntro.text') }}</div>
                </div>
                <div class="big_data">
                    <p class="detail_title">{{ $t('Public.Agriculture.lovBigData.title') }}</p>
                    <div class="data_service">
                        <ul>
                            <li v-for="(item, index) in $t('Public.Agriculture.lovBigData.list')" :key="index">
                                <p>{{ item.title }}</p>
                                <span></span>
                                <div>{{ item.text }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <my-footer></my-footer>
    </div>
</template>

<script>
// @ is an alias to /src
import MyHeader from '@/components/MyHeader.vue';
import MyFooter from '@/components/MyFooter.vue';

export default {
    name: 'Agriculture',
    components: {
        MyHeader,
        MyFooter
    },
    data() {
        return {
            show: false,
            src: ''
        };
    },
    methods: {},
    mounted() {
        this.show = true;
    }
};
</script>
<style scoped>
.banner-txt {
    text-align: justify;
}
.data_service {
    width: 100%;
    box-sizing: border-box;
    padding: 1.25rem 3.6rem 1.7rem;
    position: relative;
    min-height: 11.5rem;
}
.data_service::before {
    display: block;
    content: '';
    position: absolute;
    top: 3.6rem;
    left: 50%;
    transform: translateX(-50%);
    width: 5.28rem;
    height: 5.28rem;
    background: url(../../public/images/service/agriculture/center_logo.png) no-repeat;
    background-size: 100% 100%;
}
.data_service li {
    position: absolute;
    top: 1.35rem;
    left: 3.25rem;
    z-index: 20;
    width: 3.9rem;
    min-height: 2.24rem;
    background: #ffffff;
    box-shadow: -0.06rem 0.07rem 0.3rem 0px rgba(0, 0, 0, 0.15);
    padding: 0.3rem;
    font-size: 0.16rem;
    color: #666;
    transition: all 0.6s;
}
.data_service li:hover {
    background-color: #e8f8ff;
    cursor: pointer;
}
.data_service li:nth-child(2) {
    left: auto;
    right: 3.25rem;
}
.data_service li:nth-child(3) {
    top: 5.1rem;
}
.data_service li:nth-child(4) {
    left: auto;
    right: 3.25rem;
    top: 5.1rem;
}
.data_service li:nth-child(5) {
    top: 8.85rem;
}
.data_service li:nth-child(6) {
    left: auto;
    right: 3.25rem;
    top: 8.85rem;
}
.data_service li p {
    font-size: 0.22rem;
    font-weight: 500;
    color: #333333;
}
.data_service li div {
    text-align: justify;
    line-height: 1.5;
}
.data_service li:nth-child(2) div {
    text-align: left !important;
}
.wrap_en .data_service {
    min-height: 13.4rem;
}
.wrap_en .data_service::before {
    top: 4.8rem;
}
.wrap_en .data_service li {
    min-height: 2.95rem;
}
.wrap_en .data_service li:nth-child(3),
.wrap_en .data_service li:nth-child(4) {
    top: 5.95rem;
}
.wrap_en .data_service li:nth-child(5),
.wrap_en .data_service li:nth-child(6) {
    top: 10.55rem;
}
.data_service li span {
    display: inline-block;
    width: 0.44rem;
    height: 0.06rem;
    background: #05a3e4;
    margin: 0.07rem 0 0.2rem;
}
.banner {
    width: 100%;
    height: 5.76rem;
    padding: 1.8rem 3rem 0 3.6rem;
    font-size: 0.22rem;
    font-weight: 300;
    background: url(../../public/images/service/agriculture/banner.png) no-repeat;
    background-size: 100% 100%;
    line-height: 2;
    background-color: #31575c;
}
.banner p {
    font-size: 0.54rem;
    line-height: 1.39;
    margin-bottom: 0.2rem;
}
.content {
    padding: 1rem 0 2rem;
    color: #333;
    padding-bottom: 1rem;
}
.service_intro {
    padding: 0 3.6rem 0.8rem;
}
.intro_text {
    margin: 0.45rem auto 0;
    max-width: 12rem;
    font-size: 0.2rem;
    line-height: 2;
    text-align: justify;
    color: #555;
}
.detail_title {
    font-size: 0.32rem;
    font-weight: 600;
    text-align: center;
}
.service_type {
    margin-top: 1rem;
}
.service_type li {
    width: 100%;
    display: flex;
    padding: 0.56rem 3.5rem 0.5rem;
    position: relative;
    min-height: 3.8rem;
}
.service_type li:nth-child(2) {
    background: url(../../public/images/service/li2_bg.png) no-repeat;
    background-size: 100% 100%;
}
.service_type li:nth-child(4) {
    background: url(../../public/images/service/li4_bg.png) no-repeat;
    background-size: 100% 100%;
}
.service_type li:nth-child(1)::after,
.service_type li:nth-child(3)::after {
    position: absolute;
    bottom: 0;
    left: 4.07rem;
    z-index: -50;
    display: block;
    content: '';
    background: url(../../public/images/service/01.png) no-repeat;
    background-size: 100% 100%;
    width: 1.69rem;
    height: 1.46rem;
}
.service_type li:nth-child(2)::after,
.service_type li:nth-child(4)::after {
    left: 12.6rem;
}
.service_type li:nth-child(3)::after {
    background: url(../../public/images/service/03.png) no-repeat;
    background-size: 100% 100%;
}
.service_text {
    width: 7.2rem;
    margin-right: 0.2rem;
}
.service_img {
    width: 4.4rem;
}
.service_type li.active .service_text {
    width: 6.1rem;
}
.service_type li.active .service_img {
    margin-right: 0.62rem;
}
.service_type li.active .service_text_top {
    justify-content: flex-end;
}
.service_type li.active .service_text_top div {
    margin: 0 0 0 0.2rem;
}
.service_type li.active .service_text_middle,
.service_type li.active .service_text_bottom {
    padding: 0 0.76rem 0 0;
    text-align: right;
}
.service_text_top {
    display: flex;
    align-items: center;
    font-size: 0.26rem;
    padding-top: 0.43rem;
    padding-left: 0.5rem;
}
.service_text_top div {
    width: 0.6rem;
    margin-right: 0.2rem;
}
.service_text_middle {
    font-size: 0.16rem;
    color: #666;
    padding-left: 1.3rem;
    line-height: 2;
    text-align: justify;
}
.service_text_bottom {
    font-size: 0.18rem;
    margin-top: 0.28rem;
    padding-left: 1.3rem;
}
.service_type li.active .service_text_bottom,
.service_type li:nth-child(3) .service_text_bottom {
    margin-top: 0.5rem;
}
.service_text_bottom:hover {
    color: #05a3e4;
    cursor: pointer;
}
</style>
